import { Component } from '@opten/compiler/metadata/component';
import { createNode } from '@opten/dom/create-node';
import { getWindowScrollTop } from '@opten/dom/get-window-scroll-top';

import { isMobile } from '../../utilities/detection';
import player from '../player/player';

declare var PhotoSwipeUI_Default;
declare var PhotoSwipe;


export abstract class PhotoswipeItem {
    constructor(public el: HTMLElement) {}
}

export class PhotoswipeHtmlItem extends PhotoswipeItem {
    constructor(el: HTMLElement, public html: string) {
        super(el);

        const node = createNode(html);

        if (node.tagName.toLowerCase() === 'iframe') {
            (node as HTMLIFrameElement).width = `100%`;
            (node as HTMLIFrameElement).height = `100%`;
        }

        this.html = node.outerHTML;
    }
}

export class PhotoswipeImageItem extends PhotoswipeItem {
    public img?: HTMLImageElement;
    public msrc?: string;

    constructor(
        el: HTMLElement,
        public src: string,
        public w: number,
        public h: number
    ) {
        super(el);

        const image = el.getElementsByTagName('img')[0];

        if (image) {
            this.img = image;

            this.msrc = this.img.hasAttribute('srcset')
                ? this.img.currentSrc || this.img.src
                : this.img.src;
        }
    }
}

@Component({ className: 'js-photoswipe' })
export default class Photoswipe {
    private _triggerElements: Array<HTMLElement>;

    constructor(private element: HTMLElement) {
        this._triggerElements = Array.from(
            element.getElementsByClassName('js-photoswipe-toggler')
        ) as Array<HTMLElement>;

        const galleryId = this.element.getAttribute('data-gallery-id');

        if (galleryId) {
            const items = this._getItems(galleryId);

            this._triggerElements.forEach(trigger =>
                trigger.addEventListener('click', event => this._open(items))
            );

            this.element.addEventListener('click', event => {
                event.preventDefault();

                this._open(items, this.element);
            });
        }
    }

    private _getItems(
        galleryId: string
    ): Array<PhotoswipeHtmlItem | PhotoswipeImageItem> {
        return Array.from(
            document.querySelectorAll(`[data-gallery-id="${galleryId}"]`)
        ).map(item => {
            // todo: settings for class name
            const embed = item.getElementsByClassName(
                'js-photoswipe-video-embed'
            )[0];

            if (embed) {
                return new PhotoswipeHtmlItem(
                    item as HTMLElement,
                    embed.innerHTML
                );
            } else {
                return new PhotoswipeImageItem(
                    item as HTMLElement,
                    item.getAttribute('data-href'),
                    parseInt(item.getAttribute('data-width'), 10),
                    parseInt(item.getAttribute('data-height'), 10)
                );
            }
        });
    }

    private _open(
        items: Array<PhotoswipeHtmlItem | PhotoswipeImageItem>,
        element?: HTMLElement
    ) {
        const elements = items.map(o => o.el);
        let index = element ? elements.indexOf(element) : 0;

        // todo: settings
        // in mobile we only start the videos, we don't open the images
        // because there is no benefit at all...
        // if (isMobile()) {
        //     if (items[index] instanceof PhotoswipeHtmlItem) {
        //         player(items[index].el).play();
        //     }

        //     return;
        // }

        const options: PhotoSwipe.Options = {
            history: false,
            index,
            getThumbBoundsFn: index => {
                const item = items[index];
                const pageYScroll = getWindowScrollTop();

                if (item instanceof PhotoswipeImageItem && item.img) {
                    const rect = item.img.getBoundingClientRect();
                    return {
                        x: rect.left,
                        y: rect.top + pageYScroll,
                        w: rect.width
                    };
                } else {
                    const rect = item.el.getBoundingClientRect();
                    return {
                        x: rect.left + rect.width / 2,
                        y: rect.top + pageYScroll + rect.height / 2,
                        w: 0
                    };
                }
            }
        };

        const pswp = document.getElementById('pswp');
        const gallery = new PhotoSwipe(
            pswp,
            PhotoSwipeUI_Default,
            items,
            options
        );

        gallery.init();
        gallery.listen('close', () =>
            Array.from(pswp.getElementsByTagName('iframe')).forEach(
                (element: Element) => element.removeAttribute('src')
            )
        );
    }
}
